import { connect } from "react-redux";
import { Navigate } from "react-router-dom";

const ProtectedRoute = ({children , token})=>{
    return token ? children : <Navigate to="/Login" />
}
const mapStateToProps = (state) => {
    return {
      token: state.token,
    };
  };
export default connect(mapStateToProps)(ProtectedRoute);